/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const ActionSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`;
